import React from 'react';

const AccessibilityIconBrightnessMaxText = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="5" fill="white" />
    <g clip-path="url(#clip0_9254_96737)">
      <path
        d="M18.5042 7.62578H17.425V6.54661C17.425 6.25495 17.2208 6.05078 16.9292 6.05078H16.1125C15.8208 6.05078 15.6167 6.25495 15.6167 6.54661V7.62578H14.5375C14.2458 7.62578 14.0417 7.82995 14.0417 8.12161V8.93828C14.0417 9.22995 14.2458 9.43411 14.5375 9.43411H15.6167V10.5133C15.6167 10.8049 15.8208 11.0091 16.1125 11.0091H16.9583C17.25 11.0091 17.4542 10.8049 17.4542 10.5133V9.43411H18.5333C18.825 9.43411 19.0292 9.22995 19.0292 8.93828V8.12161C19 7.82995 18.7958 7.62578 18.5042 7.62578Z"
        fill="current"
      />
      <path
        d="M11.3583 7.74245H9.49167L5 17.7174H7.33333L8.325 15.4424H12.5833L13.575 17.7174H15.9375L11.3583 7.74245ZM9.17083 13.4883L10.4542 10.5716L11.7375 13.4883H9.17083Z"
        fill="current"
      />
    </g>
    <defs>
      <clipPath id="clip0_9254_96737">
        <rect width="14" height="14" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default AccessibilityIconBrightnessMaxText;
